module.exports = __webpack_public_path__ + "3422774f27b3dfd453b27fee6242a357.pdf";